export default __webpack_public_path__ + "static/cafe_36047-10c6409e16a9e75c7f6b7029c740aed8.png";